import React from 'react';
import '../../styles/SidebarLibrary.css';

export default function SidebarLibrary({ onMyBooksClick, onExploreNewBooksClick, onPurchasedBooksClick, onWishlistClick, onCoverMarketClick, onMyCoversClick, onDraftsClick, onTemplateGalleryClick, activeView, rejectedDraftsCount = 0 }) {
  const btn = (view) =>
    `rv-sidebar-library__button rv-sidebar-library__button--${activeView === view ? 'primary' : 'secondary'}`;

  return (
    <aside className="rv-sidebar-library">
      <nav className="rv-sidebar-library__nav" aria-label="Library navigation">
        <button className={btn('purchased')} onClick={onPurchasedBooksClick}>
          MY LIBRARY
        </button>
        {/* Leaves the Library page rather than switching `viewMode`, so this
            one never matches `activeView` and always renders secondary. That is
            correct: you are not looking at it while you are on this page. */}
        <button className={btn('templates')} onClick={onTemplateGalleryClick}>
          TEMPLATE GALLERY
        </button>
        <button className={btn('wishlist')} onClick={onWishlistClick}>
          WISHLIST
        </button>
        <button className={btn('library')} onClick={onExploreNewBooksClick}>
          EXPLORE NEW BOOKS
        </button>
        <button className={btn('myBooks')} onClick={onMyBooksClick}>
          MY BOOKS
        </button>
        <button className={btn('drafts')} onClick={onDraftsClick} style={{ position: 'relative' }}>
          MANUSCRIPTS
          {rejectedDraftsCount > 0 && (
            <span style={{
              position: 'absolute',
              top: 6,
              right: 8,
              backgroundColor: '#e65100',
              color: '#fff',
              borderRadius: '50%',
              fontSize: '0.65rem',
              fontWeight: 700,
              minWidth: 18,
              height: 18,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 4px',
            }}>
              {rejectedDraftsCount}
            </span>
          )}
        </button>

        <div className="rv-sidebar-library__divider" />
        <button className={btn('coverMarket')} onClick={onCoverMarketClick}>
          COVER MARKET
        </button>
        <button className={btn('myCovers')} onClick={onMyCoversClick}>
          MY COVERS
        </button>
      </nav>
    </aside>
  );
}